<template>
  <div class="info animate slideInRight">
    <span class="close show" @click="closed"></span>
    <div class="logInfo">
      <span class="tit show">找回密码</span>
      <span class="spancls show">{{ dataJson.tell }}</span>
      <span class="spancls show">已验证成功  {{ dataJson.yzm }}</span>
      <input class="inputcls click" :class="ispwdN ? 'wrong' : ''" type="password" @focus="focusfns" @blur="blurfns(1)" value="" v-model="newpwd" :placeholder=" $t('lan.newpwd') " />
      <input class="inputcls" :class="ispwdO ? 'wrong' : ''"  type="password" v-model="oldpwd" :placeholder=" $t('lan.conpwd') " />
      <div class="fleft codeYz m40T">
        <span class="btnsub show fleft cur" @click="updatepwd">{{ $t('lan.respwd') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { Dialog } from 'vant';
Vue.use(Dialog);
export default {
  name: 'app',
  components: {
    
  },
  props:['dataJson'],
  data(){
    return {
      lang: window.location.href.indexOf('bluejeanimages')>0 ? 1 : 0,
      newpwd:'',
      oldpwd:'',
      ver:'',
      ispwdN:false,
      ispwdO:false,
      isToyzm:false,
    }
  },
  created() {
    
  },
  mounted(){

  },
  destroyed(){
   
  },
  methods:{
    focusfns(){
        this.ispwdN=false;
        this.ispwdO=false;
    },
    blurfns(type){
        if(type==1){
            if(this.newpwd==''){
                this.ispwdN=true;
            }else{
                this.ispwdN=false;
            }
        }else{
            if(this.oldpwd==''){
                this.ispwdO=true;
            }else{
                this.ispwdO=false;
            }
        }
    },
    closed(){
      this.$emit('closeLog',true)
    },
    //先验证密码是否为空
    checknamepwd(){
      var pwd1=this.newpwd;
      var pwd=this.oldpwd;
      if(this.pwd1=='' ){
        this.ispwdN=true;
        return;
      }
      if(pwd.val()==''){
        this.oldpwd=true;
        return;
      }
    },
    async updatepwd(){
		var pwd1=this.newpwd;
		var pwd=this.oldpwd;
		if(pwd1==''){
			this.ispwdN=true;
			return;
		}
		if(pwd==''){
			this.ispwdO=true;
			return;
		}
		if(pwd1!= pwd){
			Dialog.alert({
				title: '温馨提示',
				message: '两次密码不一致',
			});
			return;
		}
		if(this.dataJson.yzType==2){
			var urls='/sms/doResetPwd2';
			var data = {
				mobile :this.dataJson.tell,
				authcode:this.dataJson.yzm,
				password:pwd
			};
		}else{
			var urls='/passport/doResetPwd2';
			var data = {
				authcode:this.dataJson.yzm,
				password:pwd,
				email:this.dataJson.tell
			};
		}

		await _this.$api.getCodepwd(urls,data).then((res)=>{
			var res = res.data; 
			if( res.result==1){  
				this.pwd=false;
				var obj={'userName':this.name,'pwd':this.pwd,'isLogin':'1'};
				localStorage.setItem('record', JSON.stringify(obj) ); 
				Dialog.alert({
					title: '温馨提示',
					message: this.$t('lan.pwdsign'),
				}).then(() => {
					  this.$emit('closeType',5)
				});
			}else{
				Dialog.alert({
					title: '温馨提示',
					message: this.$t('lan.pwdfail'),
				});
				return;
			}
		}).catch((err)=>{
			Dialog.alert({
				title: '温馨提示',
				message: '服务器请求失败稍后重试',
			})
      })
    }

  }
}
</script>
<style lang="scss" scoped>
    .info{
      width:750px;
      margin:0 auto;
      background: #fff;
      height:100%;
      position: fixed;
      top:0;
      left: 0;
      z-index: 2000;
      color:#4d4d4d;
    }
    .logInfo{
      width:670px;
      height:820px;
      position:absolute;
      top:50%;
      left:50%;
      margin:-410px 0 0 -335px;
      font-size:36px;
      .tit{
        width:100%;
        line-height:120px;
        font-size:36px;
        text-align: center;
        border-bottom:solid 1px #cbcbcb;
      }
      .spancls{
        width:630px;
        height:138px;
        line-height:138px;
        padding:0 20px;
        margin-bottom:2px;
        border-bottom:solid 1px #cbcbcb;
        font-size:30px;
      }
      .inputcls{
        width:630px;
        height:138px;
        line-height:138px;
        padding:0 20px;
        margin-bottom:2px;
        border-bottom:solid 1px #cbcbcb;
      }
      .inputcls.click{
        border-bottom:solid 3px #00a8ff; 
      }
      .btnsub{
        width:100%;
        height:100px;
        line-height:100px;
        background:#00a8ff;
        color:#fff;
        text-align: center;
        letter-spacing: 4px;
      }
      .js{
        font-size:30px;
        line-height:50px;
        text-align: center;
        float: left;
        width:100%;
      }
      .verify{
        height:70px;
        width:100%;
        color:#fff;
        float: left;
        span{
          width:200px;
          height:100%;
          background:#989898;
          display: block;
          line-height:70px;
          text-align: center;
          font-size:26px;
          margin-right:1px;
          float: left;
        }
        .click{
          background:#666;
        }
      }
      .codeYz{
        width:100%;
        height:138px;
        overflow: hidden;
        line-height:70px;
      }
      .codeYz.click{
        border-bottom:solid 1px #cbcbcb;
        margin-bottom:40px;
      }
      .putcode{
        width:330px;
        height:138px;
        background: rgba(255,255,255,.9);
        padding:0 20px;
        font-size:36px;
        line-height:138px;
        color:#999;
        letter-spacing: 4px;
      }
      .codeBtn{
        width:248px;
        height:120px;
        background:#00a8ff;
        text-align: center;
        line-height:120px;
        color:#fff;
        margin-top:8px;
        font-size:30px;
        letter-spacing: 4px;
        
      }
    
    }
    
</style>
